export default function ({ $auth, redirect }) {
  if (!$auth.user.confirmed) {
    return redirect('/confirmation')
  }
}
